var React = require('react');

function HotspotIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 3c13.255 0 24 10.745 24 24a23.925 23.925 0 0 1-7.03 16.97l-2.828-2.828A19.937 19.937 0 0 0 44 27c0-11.046-8.954-20-20-20S4 15.954 4 27a19.937 19.937 0 0 0 5.859 14.143L7.03 43.972A23.925 23.925 0 0 1 0 27C0 13.745 10.745 3 24 3zm0 9c8.284 0 15 6.716 15 15 0 4.142-1.679 7.892-4.393 10.607l-2.829-2.829A10.966 10.966 0 0 0 35 27c0-6.075-4.925-11-11-11s-11 4.925-11 11c0 3.038 1.232 5.788 3.223 7.78l-2.829 2.828A14.953 14.953 0 0 1 9 27c0-8.284 6.716-15 15-15z","fill":"#8D6CFF","key":0}),React.createElement("path",{"d":"M24 32a5 5 0 1 0 0-10 5 5 0 0 0 0 10z","fill":"#8D6CFF","key":1})]);
}

HotspotIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = HotspotIcon;

HotspotIcon.default = HotspotIcon;
